import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const dropoffNotesMachine = createTripArrayFieldMachine('dropoffNotes');
